import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import DocumentHead from 'legacyComponents/documentHead';

import { PreviewLoader } from 'apps/viewer/views/previewLoader';
import { viewerURLtoPreviewInfo } from 'libs/rendering/utils';

@withNamespaces()
@inject('routerStore')
@observer
export class ViewerPage extends React.Component {
  render() {
    const {
      routerStore: {
        params,
        route: { path },
      },
    } = this.props;

    const previewInfo = viewerURLtoPreviewInfo(`${MAIN_URL}${path}`);

    return (
      <>
        <DocumentHead
          title='Viewer'
          imagePath={previewInfo.image.url}
          videoInfo={previewInfo.video}
        />
        <PreviewLoader fileID={params.get('fileID')} isPreview />
      </>
    );
  }
}

ViewerPage.propTypes = {
  routerStore: PropTypes.object,
};
